import BillApplicableDiscountsListPopoverContent from "@/app/components/bill/BillApplicableDiscountsListPopoverContent.vue";
import { VueContentPopover } from "@/app/popover/VueContentPopover";

export class BillApplicableDiscountsListPopover extends VueContentPopover {
    constructor(options: { locationId: string; billId: string; payUseCaseId: string; selectedMainBillItemIds: string[] }) {
        super({ popoverClass: "bill-discounts-list-popover", fullscreen: false, flexHeight: true, condensed: true });

        const props = {
            locationId: options.locationId,
            billId: options.billId,
            payUseCaseId: options.payUseCaseId,
            selectedMainBillItemIds: options.selectedMainBillItemIds,
            onClose: () => this.hide(),
        };
        this.initComponent(BillApplicableDiscountsListPopoverContent, props);
    }
}
